import { Section, Button, Input, Label, Value, PaddedContent, Heading} from 'daymap-library'
import { Text } from '@fluentui/react';
function Event({EventID, Subject, StartTime, EndTime, RoomName}){

    return (
<div>
<Heading><Text variant="large">Event Details</Text></Heading>
<PaddedContent>

            <Label position="Left" text="Subject:">
                <Value>{Subject}</Value>
            </Label>
            <Label position="Left" text="Room Name:">
                <Value>{RoomName}</Value>
            </Label>
            <Label position="Left" text="Start Time:">
                <Value>{new Date(StartTime).toLocaleTimeString()}</Value>
            </Label>
            <Label position="Left" text="End Time:">
                <Value>{new Date(EndTime).toLocaleTimeString()}</Value>
            </Label>
    </PaddedContent>
</div>
    
    )
}

export default Event;